import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';
import ChatService from '../services/chat.service';
import { UploadDestination } from '../types/File/File.types';

const chatService = new ChatService();

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
type UploadKnowledgeFileArgsType = {
    file: File;
    organizationId: string;
    handleProgressEvent?: (event: AxiosProgressEvent & { name: string }) => void;
    parentId?: string;
    destination?: UploadDestination;
};

export const useUploadKnoledgeFile = () => {
    return useMutation({
        mutationFn: ({
            file,
            organizationId,
            handleProgressEvent,
            parentId,
            destination,
        }: UploadKnowledgeFileArgsType) =>
            chatService.uploadKnowledgeFile(file, organizationId, handleProgressEvent, parentId, destination),
    });
};
